import { ns } from '../global/namespace.js';

export const COLLAPSE_CLASS = ns('collapse');
